module.exports = __webpack_public_path__ + "static/media/messaging.55c6ec1b.svg";